import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { FeedImportsTable } from '@app/components/apps/FeedImport/FeedImportsTable';

const AllFeedImports: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: `/feed-imports`, breadcrumbName: `Feed Importation` }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Import',
      <BaseButton type="primary" size="small" onClick={() => navigate('/add-feed-import')}>
        Add Import
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Feed Importation</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FeedImportsTable />
        </Col>
      </Row>
    </>
  );
};

export default AllFeedImports;
